import _ from 'lodash';
import moment from 'moment';
import * as d3 from 'd3';
import helper from '../../../helper';

/* eslint no-shadow: ["error", {"allow": ["getters"]}] */
const getters = {
  indicator: (state, getters, rootState) => {
    const row = rootState.lku.Question[state.indicatorId];
    return row ? row.name : '';
  },
  indicatorAbbr: (state, getters, rootState) => {
    const row = rootState.lku.Question[state.indicatorId];
    return row ? row.abbr : '';
  },
  queryStringForAllFilteredIds: () => (filterObj) => {
    const parmsObj = {
      questionId: filterObj.indicatorId,
      multistrat: filterObj.multistrat,
      yearId: filterObj.yearId,
      stratCatId1: filterObj.stratCatId1,
      stratId1: filterObj.stratId1,
      stratCatId2: filterObj.stratCatId2,
      stratId2: filterObj.stratId2,
      responseId: filterObj.responseId,
      dataValueTypeId: filterObj.dataValueTypeId,
      legendColumn: filterObj.legendColumn,
      legendType: filterObj.legendType,
    };
    const parms = _.map(parmsObj, (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    return parms.join('&');
  },
  queryStringForExportToPdf: (state) => {
    const parmsObj = {
      CategoryId: state.GSGo.categoryId,
      ShowFootnotes: state.flags.showFootnotes,
      View: state.view,
      IndicatorId: state.stratFilters.indicatorId,
      multistrat: state.stratFilters.multistrat,
      yearId: state.stratFilters.yearId,
      stratCatId1: state.stratFilters.stratCatId1,
      stratId1: state.stratFilters.stratId1,
      stratCatId2: state.stratFilters.stratCatId2,
      stratId2: state.stratFilters.stratId2,
      responseId: state.stratFilters.responseId,
      dataValueTypeId: state.stratFilters.dataValueTypeId,
      MapClassifierId: state.mapClassifierId,
      MapClassifierCount: state.mapClassifierCount,
    };
    const parms = _.map(parmsObj, (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    return parms.join('&');
  },
  setBrowserUrlBarToReflectCurrentLPState: (state, getters, rootState) => (router) => {
    const showDebugOption = {};
    if (rootState.flags.showDebugIds) showDebugOption.showDebugIds = rootState.flags.showDebugIds;
    const parmsObj = {
      CategoryId: state.GSGo.categoryId,
      IndicatorId: state.stratFilters.indicatorId,
      ShowFootnotes: state.flags.showFootnotes,
      View: state.view,
      yearId: state.stratFilters.yearId,
      stratCatId1: state.stratFilters.stratCatId1,
      stratId1: state.stratFilters.stratId1,
      stratCatId2: state.stratFilters.stratCatId2,
      stratId2: state.stratFilters.stratId2,
      responseId: state.stratFilters.responseId,
      dataValueTypeId: state.stratFilters.dataValueTypeId,
      MapClassifierId: state.mapClassifierId,
      MapClassifierCount: state.mapClassifierCount,
    };
    // console.log('setBrowserUrlBarToReflectCurrentLPState', parmsObj);
    router.replace({
      path: '/LP',
      query: {
        ...parmsObj,
        ...showDebugOption,
      },
    });
  },
  csvExport: (state, getters, rootState) => (lpData, multistrat, indicator) => {
    const { lku } = rootState;
    const Question = indicator;
    const Year = lku.Year[state.stratFilters.yearId].name;
    const Category = state.GSGo.category;
    const { legendColumn } = state.stratFilters;

    let dataRows = lpData.slice();

    // sort rows
    dataRows = _(dataRows).map(d => ({
      ...d,
      locsort: lku.Location[d.loc].sort,
      secsort: legendColumn === 's1' || legendColumn === 's2' || legendColumn === 'rs' ? lku[legendColumn === 's1' || legendColumn === 's2' ? 'Stratification' : 'Response'][d[legendColumn]].sort : 0,
    })).orderBy(['locsort', 'secsort'], ['asc', 'asc']).value();

    dataRows = _(dataRows).map((d) => {
      let StratificationCategory1;
      let StratificationCategory2 = '';
      let Stratification1;
      let Stratification2 = '';
      switch (multistrat) {
        case '1':
          StratificationCategory1 = lku.StratificationCategory[d.sc1].name;
          Stratification1 = lku.Stratification[d.s1].name;
          break;
        case '12':
          StratificationCategory1 = lku.StratificationCategory[d.sc1].name;
          Stratification1 = lku.Stratification[d.s1].name;
          StratificationCategory2 = lku.StratificationCategory[d.sc2].name;
          Stratification2 = lku.Stratification[d.s2].name;
          break;
        case '21':
          StratificationCategory1 = lku.StratificationCategory[d.sc2].name;
          Stratification1 = lku.Stratification[d.s2].name;
          StratificationCategory2 = lku.StratificationCategory[d.sc1].name;
          Stratification2 = lku.Stratification[d.s1].name;
          break;
        default:
          throw new Error(`Unexpected multistrat value: ${multistrat}`);
      }
      return {
        Year,
        LocationAbbr: lku.Location[d.loc].abbr,
        LocationDesc: lku.Location[d.loc].name,
        Question,
        Category,
        StratificationCategory1,
        Stratification1,
        StratificationCategory2,
        Stratification2,
        Response: lku.Response[d.rs].name,
        DataValueType: rootState.dataTypes[state.stratFilters.dataValueTypeId].dataRowLabel,
        Data_Value: d.dv,
        Data_Value_Footnote_Symbol: d.fn,
        Data_Value_Footnote: d.fn ? _(rootState.footnotes).filter({ fs: d.fn, type: 'Footnote' }).value()[0].ft : '',
        Low_Confidence_Limit: d.lci,
        High_Confidence_Limit: d.hci,
        WeightedNumber: d.wn,
      };
    }).value();

    const footnotes = _(rootState.footnotes)
      .filter(f => (f.type === 'MeasureDefinitions')
      || (f.type === 'GlobalNote')
      || (f.type === 'RelatedLinks')
      || (f.type === 'SuggestedCitation')
      || (f.type === 'IndicatorDefinition' && f.qc === state.indicatorId))
      .orderBy(['type', 'sort'])
      .map(d => ({
      // FootnoteSymbol: d.fs,
        FootnoteText: d.type === 'SuggestedCitation' ? `${d.ft} [accessed ${moment().format('MMM D, YYYY')}]` : d.ft,
        Url: d.url ? helper.convertRelativeUrlToWCMSUrl(d.url) : '',
        FootnoteType: d.type,
      }))
      .value();

    return d3.csvFormat(dataRows.concat(footnotes));
  },
  dataValueType: (state, getters, rootState) => {
    const row = rootState.lku.DataValueType[state.stratFilters.dataValueTypeId];
    return row ? row.name : '';
  },
  // // todo - make these data driven:
  dataValueUnit: () => 'Percent (%)',
  dataValueUnitShort: () => '%',
  decimalPlaces: () => 1,
  mapSummary: state => `This US map presents ${process.env.SystemName508} data in ${state.mapClassifierCount} ${state.mapClassifierId} classes for the locations with available data. For an accessible view of the data, choose display table.`,
  legendCount: state => _(state.lpData).map(state.stratFilters.legendColumn).uniq().value().length,
  legendType: (state, getters, rootState) => {
    switch (state.stratFilters.legendColumn) {
      case 'rs':
        return 'Response';
      case 's1':
        return rootState.lku.StratificationCategory[state.stratFilters.stratCatId1].name;
      case 's2':
        return rootState.lku.StratificationCategory[state.stratFilters.stratCatId2].name;
      default:
        return '';
    }
  },
  chartSummary: (state, getters) => `This bar chart presents ${process.env.SystemName508} data with ${getters.legendCount} ${getters.legendType} bars for each available location on the y-axis. For an accessible view of the data, choose display table.`,
  tableSummary: (state, getters) => `This table presents ${process.env.SystemName508} data comparing ${getters.legendCount} ${getters.legendType} values (as columns) for available locations (as row subheadings) where each row subheading has the rows ${getters.dataValueType}, confidence interval, and weighted number.`,
  confidenceIntervalLabel: () => '95% CI',
};


export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/LP/getters.js